module.exports = __webpack_public_path__ + "static/media/Christmas_1.a087f00a.jpg";